import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import React, { FC } from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { fontSizes } from "@dana/MobiusOverrides/styles/typography";
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import siteMessage from "@insite/client-framework/SiteMessage";

interface Props {
    validCount: number;
    onUploadMore: () => void;
    onDone: () => void;
    wishListName?: string;
}

export interface DanaOrderUploadStep3ConfirmStyle {
    wrapper: InjectableCss;
    confirmIcon?: TypographyPresentationProps;
    titleHeading?: TypographyPresentationProps;
    subText?: TypographyPresentationProps;
    buttonsWrapper?: InjectableCss;
}

export const danaOrderUploadStep3ConfirmStyle: DanaOrderUploadStep3ConfirmStyle = {
    wrapper: {
        css: css`
            text-align: center;
            padding: 28px 0 20px;
        `
    },
    confirmIcon: {
        size: fontSizes.extraHuge,
        lineHeight: "initial",
        css: css`
            margin-bottom: 16px;
            display: block;
        `
    },
    titleHeading: {
        css: css`
            margin-bottom: 8px;
        `
    },
    subText: {
        color: themeBackgrounds.darkGray,
        css: css`
            margin-bottom: 28px;
        `
    },
    buttonsWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            gap: 8px;

             ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        flex-wrap: wrap;
                    `
                ],
                "max",
            )}
        `
    }
};

const styles = danaOrderUploadStep3ConfirmStyle;

const DanaOrderUploadStep3Confirm: FC<Props> = ({ validCount, onUploadMore, onDone, wishListName }) => (
    <StyledWrapper {...styles.wrapper}>
        <Typography {...styles.confirmIcon}>✅</Typography>
        <Typography {...styles.titleHeading} variant="h3" as="h2">{translate("Parts Added to Mylist")}</Typography>
        <Typography {...styles.subText} as="p">
            {validCount} {siteMessage("Dana_WishList_PartUpload_PartsAddedSuccess")}
        </Typography>
        <StyledWrapper {...styles.buttonsWrapper}>
            <Button
                variant="secondary"
                onClick={onUploadMore}
                data-test-selector="danaOrderUpload_uploadMore"
            >
                {translate("Upload More Parts")}
            </Button>
            <Button onClick={onDone} data-test-selector="danaOrderUpload_done">
                {translate("Done")}
            </Button>
        </StyledWrapper>
    </StyledWrapper>
);

export default DanaOrderUploadStep3Confirm;
